<template lang="pug">

.l-page.pt-4
  .lessons-container
    navigations(
      :start-date="startDate"
      :end-date="endDate"
    )

    t-loader(v-if="loading")

    template(v-else)
      .weekdays-empty.mt-8(v-if="!days.length") Нет занятий

      template(v-else)
        template(v-if="lessonsColumnDirection && $vuetify.breakpoint.name !== 'xs'")
          .mt-6
          template(v-for="day, i in days")
            .mt-6(v-if="i > 0")
            card-lessons-column(
              :weekday="day.weekday"
              :times="day.times"
            )

        template(v-else)
          v-row.mt-8
            v-col(v-for="day in days" :key="day.weekday" :cols="countCols")
              card-lessons(
                :weekday="day.weekday"
                :times="day.times"
                is-cabinets
              )

  .mt-10

</template>

<script>
import { mapGetters, mapState } from 'vuex'
import navigations from './components/navigations'
import cardLessons from './components/card-lessons/cardLessons'
import cardLessonsColumn from './components/column-lessons/cardLessonsColumn'
import moment from 'moment'

export default {
  name: 'CabinetLessons',

  components: {
    navigations,
    cardLessons,
    cardLessonsColumn
  },

  computed: {
    ...mapState('lessons/cabinet', [
      'cabinet',
      'lessons',
      'startDate',
      'endDate',
      'loading'
    ]),
    ...mapGetters('lessons/cabinet', ['days']),
    ...mapState('navigations', ['date']),
    ...mapGetters('bootstrap', ['isSchool', 'lessonsColumnDirection']),

    isMobile() {
      return ['xs'].includes(this.$vuetify.breakpoint.name)
    },

    isTablet() {
      return ['xs', 'sm'].includes(this.$vuetify.breakpoint.name)
    },

    countCols() {
      if (this.isMobile) return 12
      if (this.isTablet) return 6

      return 4
    },
  },

  async created() {
    const date = moment(this.$route.query.date).isoWeekday(1).format('YYYY-MM-DD')
    const response = await this.$store.dispatch('lessons/cabinet/fetch', {
      cabinetId: this.$route.params.cabinetId,
      date,
    })

    if (!response.cabinet) {
      this.$router.push({
        name: 'main',
      })
      return
    }

    this.$store.commit('navigations/updateDate', date)

    this.$store.commit('breadcrumbs/update', [
      { text: this.isSchool ? 'Кабинеты' : 'Аудитории', exact: true, to: { name: 'cabinets' } },
      { text: `${this.cabinet.name}`.trim() },
    ])
  },

  watch: {
    date(date) {
      this.$store.dispatch('lessons/cabinet/fetch', {
        cabinetId: this.$route.params.cabinetId,
        date,
      })
    },
  },
}
</script>

<style lang="sass" scoped>

.weekdays-empty
  text-align: center
  font-size: 18px
  font-weight: 700
  width: 100%
  color: #6c6c6c

.t-loader
  margin-top: 80px

.lessons-container
  max-width: 1200px
  margin: 0 auto
  padding: 0 24px

  @media (max-width: 768px)
    padding: 0 16px

  @media (max-width: 480px)
    padding: 0 20px

</style>
